import {Injectable} from '@angular/core';
import {ErrorService} from '../../lib-core/services/error.service';
import {TabelleControl, Tabellengestaltung, UiInputControl} from '../models/uiArtefakt';
import {UIArtefaktTyp} from '../models/uiArtefaktTyp';

@Injectable()
export class TabellenService {
  displayedColumns: string[];
  rows: UiInputControl[];
  header: UiInputControl[];
  footer: UiInputControl[];
  columnWidths: string[];
  sumOfWidths: number;
  tableWidth: string;

  constructor(private _errorService: ErrorService) {
  }

  public createTable(uiArtefakt: TabelleControl) {
    this.columnWidths = [];
    this.sumOfWidths = 0;
    if (uiArtefakt.UIArtefakt.length === 0) {
      this._errorService.pushWarningMessage(`Die Tabelle ${uiArtefakt.Identifikator} enthält keine Zeilen`);
      return;
    }
    this.updateTableContent(uiArtefakt);
    this.displayedColumns = (uiArtefakt.UIArtefakt[0] as UiInputControl).UIArtefakt.map(artefakt => artefakt.Identifikator);

    if (this.header.length > 1) {
      this._errorService.pushErrorMessage(`Die Tabelle ${uiArtefakt.Identifikator} enthält mehr als ein Artefakt vom Typ Tabellenkopf.
      Tatsächliche Anzahl: ${this.header.length}`);
    }

    if (this.footer.length > 1) {
      this._errorService.pushErrorMessage(`Die Tabelle ${uiArtefakt.Identifikator} enthält mehr als ein Artefakt vom Typ Tabellenfuss.
      Tatsächliche Anzahl: ${this.footer.length}`);
    }

    if (uiArtefakt.SichtbareZeilen && this.rows.length < uiArtefakt.SichtbareZeilen) {
      this._errorService.pushWarningMessage(`Das Tabellenattribut 'Sichtbare Zeilen' der Tabelle ${uiArtefakt.Identifikator} ist
      größer (${uiArtefakt.SichtbareZeilen}) als die Anzahl an Zeilen(${this.rows.length})`);
    }

  }

  public updateTableContent(uiArtefakt: TabelleControl) {
    this.header = this.calculateTableRowsWithIdentifier(uiArtefakt, UIArtefaktTyp.TABELLENKOPF);
    this.rows = this.calculateTableRowsWithIdentifier(uiArtefakt, UIArtefaktTyp.TABELLENINHALT);
    this.footer = this.calculateTableRowsWithIdentifier(uiArtefakt, UIArtefaktTyp.TABELLENFUSS);
  }

  public calculateTableRowsWithIdentifier(uiArtefakt: TabelleControl, identifier: string): UiInputControl[] {
    const rows = ((uiArtefakt.UIArtefakt as UiInputControl[]).filter(artefakt => artefakt.UIArtefakttyp === identifier));
    rows.forEach(row => {
      if (row.Tabellenzeilengestaltung?.UITabellenzeile !== undefined) {
        row.Tabellenzeilengestaltung.UITabellenzeile.forEach(zeile => {
          let zellennummer = null;
          let zellenspanne = null;
          zeile.UITabellenzelle.forEach(zelle => {
            if (zelle.Attribut === 'Tabellenzellennummer') {
              zellennummer = zelle.Wert;
            } else if (zelle.Attribut === 'Tabellenzellenspanne') {
              zellenspanne = zelle.Wert;
            }
            if (zellennummer != null && zellenspanne != null) {
              row.UIArtefakt[zellennummer - 1]['Tabellenzellenspanne'] = zellenspanne;
            }
          });
        });
      }
      row.UIArtefakt.forEach(artef => {
        if (!artef['Tabellenzellenspanne']) {
          artef['Tabellenzellenspanne'] = 1;
        }
      });
    });
    return rows;
  }


  public setTabellengestaltung(tabellengestaltung: Tabellengestaltung, identifkator: string) {
    tabellengestaltung.UITabellenzeile.forEach(zeile => {
      let spaltenNummer = null;
      let spaltenBreite = null;
      zeile.UITabellenzelle.forEach(zelle => {
        if (zelle.Attribut === 'Tabellenspaltennummer') {
          spaltenNummer = zelle.Wert;
        } else if (zelle.Attribut === 'Tabellenspaltenbreite') {
          spaltenBreite = zelle.Wert;
        }
        if (spaltenNummer != null && spaltenBreite != null) {
          this.columnWidths[spaltenNummer - 1] = spaltenBreite + '%';
          this.sumOfWidths += spaltenBreite as number;
        }
      });
      this.tableWidth = this.sumOfWidths + '%';
    });
    if (this.sumOfWidths !== 100) {
      this._errorService.pushWarningMessage(`Hinweis: Die Tabellenbreiten für '${identifkator}' sind gesetzt,
         summieren sich aber zu ${this.sumOfWidths}%, statt zu 100%`);
    }
  }

  public setDefaultWidths() {
    this.rows.forEach(_ => this.columnWidths.push(100 / (this.rows[0].UIArtefakt.length) + '%'));
  }
}
